import Reflux from 'reflux';

export default Reflux.createActions([
  'update',
  'updateError',
  'updateSuccess',
]);



/** WEBPACK FOOTER **
 ** ./app/actions/incidentActions.jsx
 **/